/*
    Enable the ability of clear error input field by clicking the error indicator icon
*/
define('shared/initializer/form/adapters/mixins/ErrorClearable',[
    '$',
    'shared/lib/RSVP'
], 
function ( $, RSVP ) {
    'use strict';

    function handleClear() {
        var $el = $(this);
        $el.siblings('input').val('').focus();
    }

    function handlePointer() {
        var $el = $(this);
        $el.css({
            cursor: 'pointer'
        });
    }

    function Ctor() { }

    Ctor.prototype.doPageLoad = function( ) {
        var me = this;
        
        me.$form.on('click', '.form-control-feedback.show-when-error', handleClear);
        me.$form.on('mouseover', '.form-control-feedback.show-when-error', handlePointer);

        return RSVP.resolve();
    };

    return Ctor;
});
